import React from 'react';
import './Footer.scss';

function Footer(props) {
  return (
    <div className={'Footer ' + props.windowSize}>
      <p id="copyright-text">Copyright © Basler Electric Company 2023</p>
    </div>
  );
}

export default Footer;